<!-- <nav class="cmx-main-nav">
  <div class="cmx-logo">
    <a class="cmx-logo__link" href="index.html">
      <img src="../../../../assets/images/svg/Ignite_LogoBlanco.svg" alt="logo">
    </a>
  </div>
  <div class="cmx-main-nav__items">
    <div class="cmx-main-nav__item nav-notifications-item">
      <div class="cmx-notifications">
        <Select>
          <option value="">ENGLISH</option>
        </Select>
      </div>
    </div>
    <div class="cmx-main-nav__item-separator">
    </div>

  </div>
  <div class="cmx-sub-nav-loader">
  </div>
</nav> -->
<!-- <cwc-header _ngcontent-off-c17="" show-menu-button="true" slot="header" variant="positive" class="hydrated" dir="ltr">Either Menu or tools</cwc-header> -->
header works!!!
